<template>
  <div id="app"
       class="mobile-main">
    <!-- fixed使得导航栏固定在顶部 -->
    <van-nav-bar class="mobile-header"
                 fixed
                 title=""
                 left-text="返回"
                 right-text="登录"
                 @click-left="onClickLeft"
                 @click-right="onClickRight">
      <!-- 使用插槽定义左侧内容 -->
      <template #left>
        <van-image width="49"
                   height="40"
                   fit="contain"
                   :src="require('@/assets/mobile/lujiaLogo.png')" />
      </template>
      <!-- 如果用户点击登录页面 -->
      <template #right
                v-if="$root.isLogin">
        <van-image width="35"
                   height="35"
                   fit="contain"
                   round
                   :src=" userdetailList.avatar ? userdetailList.avatar : headAvatar" />
      </template>
    </van-nav-bar>
    <div class="mobile-container">
      <router-view class="mobile-pages"
                   v-if="isRouterAlive" />
    </div>
    <div class="mobile-footer"
         v-show="showFooter">
      <!-- 每个元素两侧间隔相等 -->
      <div class="offical-info">
        <span @click="showOfficial = true">官方公众号</span>
        <span @click="feedback()">
          意见反馈
        </span>
        <a href="tel:15142048012">联系我们</a>
      </div>
      <div class="regist-info">
        备案号：辽宁ICP备11005457号-6
      </div>
      <div class="copyright-info">
        Copyright © 2016.沈阳美行科技有限公司 保留所有版权
      </div>
    </div>
    <van-popup v-model="showOfficial">
      <div class="qr-code-area">
        <van-image width="150"
                   height="150"
                   fit="contain"
                   :src="require('@/assets/images/lujia.jpg')" />
        <div>长按保存二维码到相册</div>
        <div>打开微信扫一扫</div>
      </div>
    </van-popup>
    <van-popup v-model="showAdvice">
      <div class="advie-feedback">
        <div class="advice-feedback-title">跟我们说点什么吧</div>
        <van-field v-model="feedbackContent"
                   rows="2"
                   type="textarea"
                   maxlength="50"
                   placeholder="请输入留言"
                   show-word-limit />
        <van-button type="primary"
                    class="advice-feedback-button"
                    @click="submitFeedback">提交</van-button>
      </div>
    </van-popup>
  </div>
</template>
<script>
import headAvatar from "@/assets/images/avatar.png";
import { NavBar, Col, Row, Popup, Field, Button, Image as VanImage } from 'vant';
import { mapState, mapActions } from "vuex"
import { saveFeedback } from '@/axios/service/travel';
import { mobileMsgSuc, mobileMsgErr } from '@/utils/MobileGlobal.js';
export default {
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [Popup.name]: Popup,
    [Col.name]: Col,
    [Row.name]: Row,
    [NavBar.name]: NavBar,
    VanImage
  },
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      clientHeight: document.documentElement.clientHeight,
      showFooter: false,
      feedbackContent: "",
      showAdvice: false,
      showOfficial: false,
      headAvatar: headAvatar,
      isRouterAlive: true
    };
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
    window.onresize = () => {
      if (this.clientHeight > document.documentElement.clientHeight) {
        this.showFooter = false;
      } else {
        this.showFooter = true;
      }
    }
  },
  beforeDestroy () {
  },
  computed: {
    ...mapState("PersonalStore", ["userdetailList"])
  },
  methods: {
    ...mapActions("PersonalStore", ["getUserdetail"]),
    handleScroll () {
      //变量scrollTop是滚动条滚动时，距离顶部的距离
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      //变量windowHeight是可视区的高度
      let windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
      //变量scrollHeight是滚动条的总高度
      let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      //滚动条到底部的条件
      if (scrollTop + windowHeight == scrollHeight) {
        this.showFooter = true
      } else {
        this.showFooter = false
      }
    },
    //刷新页面的方法
    reload () {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      })
    },
    submitFeedback () {
      saveFeedback({
        userId: this.$cookie.get("userInfo_userId"),
        feedbackContent: this.feedbackContent
      }).then(json => {
        if (json.respCode === 100) {
          //关闭用户反馈
          this.showAdvice = false;
          this.feedbackContent = "";
          mobileMsgSuc("发送成功");
        } else {
          mobileMsgErr("发送失败");
        }
      });
    },
    feedback () {
      let loginUserInfo = this.$cookie.get("userInfo_userId");
      if (loginUserInfo) {
        this.showAdvice = true;
      } else {
        //跳转至登录页
        this.$router.push({ name: 'login' });
      }
    },
    onClickLeft () {
      if (this.$route.name !== "home") {
        this.$router.push({ name: "home" })
      }
    },
    onClickRight () {
      if (this.$root.isLogin) {
        this.$router.push({ name: "person" });
      } else {
        this.$router.push({ name: "login" });
      }
    }
  },
  watch: {
  },
  created () {
    //获取用户详情
    if (this.$route.name !== "person") {
      if (this.$cookie.get("userInfo_userId") !== undefined) {
        this.getUserdetail({ userId: this.$cookie.get("userInfo_userId") });
      }
    }
    //根据用户信息修改登录状态
    let userId = this.$cookie.get("userInfo_userId");
    this.$root.verificationLogin(userId ? true : false);
  }
};
</script>
<style lang="css">
</style>
<style lang="scss">
</style>
<style lang="less">
.mobile-main {
  width: 100%;
  height: 100%;
  position: relative;
  .mobile-header {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    height: 54px;
    .van-nav-bar__text {
      font-size: 16px;
      color: #57dec1;
    }
  }
  .mobile-container {
    position: absolute;
    left: 0;
    right: 0;
    top: 54px;
    padding-bottom: 112px;
    overflow: visible;
  }
  .mobile-footer {
    box-sizing: border-box;
    height: 112px;
    background-color: #3e3e43;
    width: 100%;
    position: fixed;
    bottom: 0px;
    color: #999999;
    padding-top: 27px;
    padding-bottom: 16px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .offical-info {
      padding-left: 47px;
      padding-right: 62px;
      display: flex;
      justify-content: space-around;
      font-size: 14px;
      a {
        color: #999999;
      }
    }
    .regist-info {
      font-size: 12px;
    }
    .copyright-info {
      height: 13px;
      font-size: 12px;
    }
  }
  .qr-code-area {
    padding: 10px;
    font-size: 14px;
  }
  .advie-feedback {
    width: 250px;
    padding: 10px;
    .advice-feedback-title {
      font-size: 18px;
    }
    .advice-feedback-button {
      margin-top: 10px;
    }
  }
}
</style>
